import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from '@environment';
import { ClientForm } from 'src/sb-modules/Frontend-form-field-module/common/models/client-form.model';
import { AddSurveyBody } from '../../../sb-modules/Frontend-form-field-module/common/models/add-survey-body.model';

@Injectable({
    providedIn: 'root',
})
export class SurveyService {
    constructor(private httpClient: HttpClient) {}

    getForm(token: string): Observable<ClientForm> {
        return this.httpClient.get<ClientForm>(environment.apiInboxUrl + 'surveyFormPortal', {
            headers: { 'x-token': token },
        });
    }

    send(survey: AddSurveyBody, token: string): Observable<void> {
        return this.httpClient.post<void>(environment.apiInboxUrl + 'surveyFormPortal', survey, {
            headers: { 'x-token': token },
        });
    }
}
